import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';

import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import withStyles from 'isomorphic-style-loader/withStyles';

import Link from '../../../components/Link/Link';
import SkholeIcon36 from '../../../components/statelessComponents/Icons/SkholeIcon36';

import s from './NavBar.scss';

const Header = ({
  disableGutters,
  backTooltipTitle,
  backIconRoute,
  mainTitle,
  menuProps,
}) => (
  <AppBar className={s.appBar} color="default">
    <Toolbar disableGutters={disableGutters} className={s.toolbar}>
      <Tooltip title={backTooltipTitle}>
        <IconButton
          className={s.backToCourseBtn}
          component={Link}
          to={backIconRoute}
        >
          <ChevronLeftIcon />
        </IconButton>
      </Tooltip>
      <Typography
        variant="h6"
        component="h2"
        color="inherit"
        className={classNames(s.pageTitle)}
        data-test="header-title"
        noWrap
      >
        {mainTitle}
      </Typography>
      {menuProps.isVisible && (
        <IconButton
          data-test-id="cNkwBpKhwTR-Tg4vWgh9n"
          color="inherit"
          onClick={menuProps.onClick}
          buttonRef={n => {
            menuProps.buttonRef(n);
          }}
          className={s.menuButton}
        >
          <SkholeIcon36 className={s.menuIcon} />
          {/* <div className={s.menuIcon} /> */}
        </IconButton>
      )}
    </Toolbar>
  </AppBar>
);

Header.propTypes = {
  disableGutters: PropTypes.bool.isRequired,
  backTooltipTitle: PropTypes.string.isRequired,
  backIconRoute: PropTypes.string.isRequired,
  menuProps: PropTypes.shape({
    onClick: PropTypes.func,
    buttonRef: PropTypes.func,
    isVisible: PropTypes.bool,
  }),
  mainTitle: PropTypes.string,
};

Header.defaultProps = {
  mainTitle: '',
  menuProps: {
    buttonRef: () => {},
    onClick: () => {},
    isVisible: true,
  },
};

export default withStyles(s)(Header);
